import { render, staticRenderFns } from "./TryBetaPill.vue?vue&type=template&id=6bd67d88"
import script from "./TryBetaPill.vue?vue&type=script&lang=js"
export * from "./TryBetaPill.vue?vue&type=script&lang=js"
import style0 from "./TryBetaPill.vue?vue&type=style&index=0&id=6bd67d88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports